<div class="company-block" *ngIf="visible">
  <div class="company-menu">
    <div class="menu-left" *ngIf="!qparam?.score">Sentiment Events</div>
    <div class="menu-left" *ngIf="qparam?.score">
      <span class="score-icon" *ngIf="!['bb'].includes(qparam.score)">
        <svg-icon src="assets/icon/o_sentiment.svg"></svg-icon>
      </span>
      <span>Sentiment Events</span>
    </div>
  </div>
  <div class="company-treemap" *ngIf="iready['Events']; else loadingEvents">
    <ng-container *ngFor="let item of orderedEvents">
      <app-event-row
        *ngIf="item.count > 0"
        [name]="item.event.name"
        [value]="item.count"
        [prevValue]="item.count_prev"
        valueFormat="count"
        [maxValue]="maxCount"
        [impact]="item.impact ?? 1"
        [active]="qparam?.eventid === item.event.id"
        [sole]="!!qparam?.score"
        [mobile]="(screenSize$ | async)?.isMobile"
        [series]="eventSeriesMap?.get(item.event.id)"
        [microTimeframe]="focusedTimeframe"
        [showSparkline]="
          !!qparam?.score && eventSeriesMap?.size > 0 && !!focusedTimeframe
        "
        [showTemporality]="
          !!qparam?.score && hasTemporalityAnalytics && !!focusedTimeframe
        "
        [temporalityWidths]="temporalityWidths(item.event.id)"
        (rowClick)="iEvent(item)"
      ></app-event-row>
    </ng-container>
    <div *ngIf="events === 0" class="noevent">NO EVENTS</div>
  </div>
  <ng-template #loadingEvents>
    <div class="loading" *ngIf="loading['Events']">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="nodata" *ngIf="nodata['Events']">NO DATA AVAILABLE</div>
    <div class="nodata" *ngIf="!nodata['Events'] && !loading['Events']">
      NO RESULTS FOUND, CHECK APPLIED FILTERS
    </div>
  </ng-template>
</div>
